import { classNames } from "helpers";
import { ModalBodyProps } from "./types";

const ModalBody: React.FC<ModalBodyProps> = (props: ModalBodyProps) => {
  const { children, overflow = true, fixedFooterSpacing = true } = props;

  return (
    <div className={classNames(
      "flex-1 min-h-0 scrollbar-hide",
      fixedFooterSpacing ? "pb-16" : "",
      overflow ? "overflow-y-auto" : "overflow-visible"
    )}>
      {children}
    </div>
  );
};

export default ModalBody;
